export default {
  // Generic templates storage by type
  templates: {
    engagement_letter: [],
    docket_entry_notification: [],
    short_message: [],
  },

  // Loading states by template type
  loading: {
    engagement_letter: false,
    docket_entry_notification: false,
    short_message: false,
  },

  // Languages for template translations
  languages: [],
  languagesLoading: false,
}
